import { Box } from '@material-ui/core';
import styled from 'styled-components';

const EditorViewport = styled(Box).attrs((restProps) => ({
  padding: 2,
  display: 'flex',
  justifyContent: 'center',
}))``;
export default EditorViewport;
